import { NgZone } from '@angular/core';
import * as moment from 'moment';

export class CommonUtils {

    public static htmlDecode(input: string) {
        const doc = new DOMParser().parseFromString(input, 'text/html');
        return doc.documentElement.textContent;
    }

    public static isNumeric(val: any): val is number | string {
        // parseFloat NaNs numeric-cast false positives (null|true|false|"")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        // adding 1 corrects loss of precision from parseFloat (#15100)
        return (!(Array.isArray(val))) && (val - parseFloat(val) + 1) >= 0;
    }

    static padLeft(text: string, padChar: string, size: number): string {
        if (text !== undefined && text !== null && size > text.length) {
            return (String(padChar).repeat(size) + text).substr((size * -1), size);
        }
        return text;
    }

    static padRight(text: string, padChar: string, size: number): string {
        if (text !== undefined && text !== null && size > text.length) {
            return (text + String(padChar).repeat(size)).substr(0, size);
        }
        return text;
    }

    static padLeftWithZeros(num: number, size: number): string {
        let s = String(num);
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }

    static lwDelay(thisObj: any, ngZone: NgZone, func: (...args: any[]) => void, ...funcArgs: any[]) {
        ngZone.runOutsideAngular(() => {
            requestAnimationFrame(() => {
                ngZone.run(() => {
                    func.apply(thisObj, funcArgs);
                });
            });
        });
    }

}
